import { render, staticRenderFns } from "./comp_ProductPrevPrice.vue?vue&type=template&id=174b01a8&"
import script from "./comp_ProductPrevPrice.vue?vue&type=script&lang=js&"
export * from "./comp_ProductPrevPrice.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductPrevPrice.vue?vue&type=style&index=0&id=174b01a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports